import React from 'react';
import { TabContainer } from 'assets/containers/AssetDetailView/styles';

const UserTabView = ({ tabs, onTabChange, activeTab }) => {
  const items = tabs.map(tab => ({
    key: tab.title,
    label: tab.title,
    children: tab.content,
  }));

  return <TabContainer items={items} onChange={onTabChange} activeKey={activeTab} style={{ overflow: 'visible' }} />;
};

export default UserTabView;
